import { App } from '@capacitor/app';
import { createApp } from 'vue';
import { GChart } from 'vue-google-charts';
import SmoothScroll from 'smoothscroll-polyfill';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import * as far from './store/far';
import * as fas from './store/fas';
import VueApp from './App';
import PageBar from './components/ui/pageBar';
import CustomInput from './components/ui/customInput';
import ModalWindow from './components/ui/modalWindow';
import ContactForm from './components/ui/contactForm';
import { store } from './store/store';
// import { default as store } from './store/store';
import sdk from './sdk/sdk';
import InputSuggest from './components/ui/inputSuggest';
import InputDropdown from './components/ui/inputDropdown';
import TableFilter from './components/ui/tableFilter';
import OperatorInput from './components/ui/operatorInput';
import MultiDropdown from './components/ui/multiDropdown';

const app = createApp(VueApp);

library.add(far, fas);
app.component('awesomeIcon', FontAwesomeIcon);
app.component('pagerElement', PageBar);
app.component('contactForm', ContactForm);
app.component('customInput', CustomInput);
app.component('modalWindow', ModalWindow);
app.component('inputSuggest', InputSuggest);
app.component('inputDropdown', InputDropdown);
app.component('tableFilter', TableFilter);
app.component('operatorInput', OperatorInput);
app.component('multiDropdown', MultiDropdown);
app.component('GChart', GChart);

app.use(sdk);
app.use(store);

app.config.productionTip = false;

SmoothScroll.polyfill();

/* eslint-disable */
Date.prototype.toLocaleDateString = function () {
  return `${this.getUTCDate()}-${this.getUTCMonth() + 1}-${this.getUTCFullYear()}`;
};
/* eslint-enable */

app.mixin({
  methods: {
    formatPrice(value, noCent = false, decimals = 2) {
      let n = decimals;
      if (noCent) {
        n = 0;
      }
      const s = '.';
      const c = ',';
      /* eslint-disable */
      const re = '\\d(?=(\\d{3})+' + (n > 0 ? '\\D' : '$') + ')';
      const num = Number(value).toFixed(Math.max(0, ~~n));
      /* eslint-enable */

      const result = (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), `$&${(s || ',')}`);
      return result === '-0' ? 0 : result;
    },
    getQueryVariable(variable) {
      const query = window.location.search.substring(1);
      const vars = query.split('&');
      for (let i = 0; i < vars.length; i += 1) {
        const pair = vars[i].split('=');
        if (pair[0] === variable) {
          return pair[1];
        }
      }
      return (false);
    },
    readCookie(name) {
      const nameEQ = `${name}=`;
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i += 1) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    },
    createCookie(name, value, expire = 30) {
      const date = new Date();
      date.setTime(date.getTime() + (expire * 60 * 1000));
      document.cookie = `${name}=${value}; expires=${date.toGMTString()}; path=/; SameSite=strict`;
    },
    eraseCookie(name) {
      this.createCookie(name, '', -1);
    },
    windowPrint() {
      window.print();
    },
    PMT(ir, np, pv, fv, type) {
      /*
       * ir   - interest rate per month
       * np   - number of periods (months)
       * pv   - present value
       * fv   - future value
       * type - when the payments are due:
       *        0: end of the period, e.g. end of month (default)
       *        1: beginning of period
       */
      if (!fv) fv = 0;
      if (!type) type = 0;

      if (ir === 0) return -(pv + fv) / np;

      const pvif = (1 + ir) ** np;
      let pmt = (-ir * pv * (pvif + fv)) / (pvif - 1);

      if (`${type}` === '1') pmt /= 1 + ir;

      return pmt;
    },
    calcAowAge(birth, plusYears = 5, aowDate = false) {
      let aowAge = '';
      if (birth) {
        const dateArray = birth.split('T')[0].split('-');
        const year = Number(dateArray[0]) + Number(plusYears);
        const month = Number(dateArray[1]) - 1;
        const day = Number(dateArray[2]);
        const hour = 12; // force hour for timezone stuff
        const birthday = new Date(birth);

        if (birthday < new Date('1948-01-01')) {
          aowAge = new Date(year + 65, month, day, hour);
        } else if (birthday < new Date('1948-12-01')) {
          aowAge = new Date(year + 65, month + 1, day, hour);
        } else if (birthday < new Date('1949-11-01')) {
          aowAge = new Date(year + 65, month + 2, day, hour);
        } else if (birthday < new Date('1950-10-01')) {
          aowAge = new Date(year + 65, month + 3, day, hour);
        } else if (birthday < new Date('1951-07-01')) {
          aowAge = new Date(year + 65, month + 6, day, hour);
        } else if (birthday < new Date('1952-04-01')) {
          aowAge = new Date(year + 65, month + 9, day, hour);
        } else if (birthday < new Date('1953-01-01')) {
          aowAge = new Date(year + 66, month, day, hour);
        } else if (birthday < new Date('1955-09-01')) {
          aowAge = new Date(year + 66, month + 4, day, hour);
        } else if (birthday < new Date('1956-06-01')) {
          aowAge = new Date(year + 66, month + 7, day, hour);
        } else if (birthday < new Date('1957-03-01')) {
          aowAge = new Date(year + 66, month + 10, day, hour);
        } else if (birthday < new Date('1961-01-01')) {
          aowAge = new Date(year + 67, month, day, hour);
        } else if (birthday < new Date('1963-10-01')) {
          aowAge = new Date(year + 67, month + 3, day, hour);
        } else if (birthday < new Date('1966-07-01')) {
          aowAge = new Date(year + 67, month + 6, day, hour);
        } else if (birthday < new Date('1970-04-01')) {
          aowAge = new Date(year + 67, month + 9, day, hour);
        } else if (birthday < new Date('1973-01-01')) {
          aowAge = new Date(year + 68, month, day, hour);
        } else if (birthday < new Date('1975-10-01')) {
          aowAge = new Date(year + 68, month + 3, day, hour);
        } else if (birthday < new Date('1979-07-01')) {
          aowAge = new Date(year + 68, month + 6, day, hour);
        } else if (birthday < new Date('1982-04-01')) {
          aowAge = new Date(year + 68, month + 9, day, hour);
        } else if (birthday < new Date('1986-01-01')) {
          aowAge = new Date(year + 69, month, day, hour);
        } else if (birthday < new Date('1989-10-01')) {
          aowAge = new Date(year + 69, month + 3, day, hour);
        } else {
          aowAge = new Date(year + 69, month + 6, day, hour);
        }
        if (!aowDate) {
          aowAge = new Date(`${aowAge.getFullYear()}-12-31 12:00`);
        } else {
          aowAge = new Date(aowAge);
        }
      }
      return aowAge;
    },
  },
});

// new Vue({ // eslint-disable-line no-new
//   el: '#app',
//   store,
//   // eslint-disable-next-line
//   render: createElement => createElement(VueApp),
// });

if (process.env.NODE_ENV === 'production') {
  app.config.devtools = false;
}

function onDeviceReady() {
  window.mobile = true;
}
document.addEventListener('deviceready', onDeviceReady, false);

App.addListener('appUrlOpen', (data) => {
  const parts = data.url.split('?', 2);
  window.location.href = `?${parts[1] ? parts[1] : ''}`;
});

app.mount('#app');
